import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/shiftSettings`;

export const ROUTE: RouteDefinition = `${baseRoute}/shiftSettings`;

export const URL = (): RouteDefinition => `${baseRoute}/shiftSettings`;
